const { default: CompletionRecord } = require("../../../model/CompletionRecord");
const { default: CompletionTranscriptRecord } = require("../../../model/CompletionTranscriptRecord");
const { default: ContainerModel } = require("../../../model/ContainerModel");
const { default: ItemModel } = require("../../../model/ItemModel");
const Constants = require("../../../utils/Constants");

/**
 * Finds the Completion Transcript Record for a provided invotory 
 * item (either Item or Container) from the Completion Record.
 * 
 * @param {CompletionRecord} completionRecord 
 * @param {ContainerModel | ItemModel} item 
 * @returns {CompletionTranscriptRecord} The CompletionTranscriptRecord object or null if its not found
 */
export const findItemCompletionTranscriptRecord = (completionRecord, item) => {
  let result = completionRecord.getTranscripts().filter( 
    (t) => {
      // Need to check for if it is a container, as items and containers are stored
      // in different tables they can have the same ID value and result in the wrong
      // Completion Transcript Record being returned.
      return t.getItemId() === item.getId() && t.isContainer() == item.isContainer();
    }
  );

  return result.length > 0 ? result[0] : null;
}

/**
 * Finds the existing transcript record and updates it with the new date, or if there
 * is none, pushes a new one into the list.
 * @param {*} completionRecord 
 * @param {*} existingCompletionTranscriptRecord 
 * @param {*} newCompletionTranscriptRecord 
 * @returns 
 */
export const updateItemsCompletionTranscriptRecord = (completionRecord, existingCompletionTranscriptRecord, newCompletionTranscriptRecord) => {

  if (existingCompletionTranscriptRecord === null) {
    // Newly marked in item, no existing transcript exists. Push the created one 
    // from above into the list.
    completionRecord.getTranscripts().push(newCompletionTranscriptRecord);
  } else {
    let updatedTranscript = existingCompletionTranscriptRecord;
    let indexToInsert = completionRecord.getTranscripts().indexOf(updatedTranscript);
    updatedTranscript.setPresent(newCompletionTranscriptRecord.getPresent());
    updatedTranscript.setNotes(newCompletionTranscriptRecord.getNotes());
    completionRecord.getTranscripts()[indexToInsert] = updatedTranscript;
  }

  return completionRecord;
}

/**
   * Calualates the percentage of items completed (either present, absent or issue) in a Inventory transcription
   * so that the value can be displayed in the Locker Selection View.
   * This is not used anywhere else, but has been moved into the Utils file to allow for testing.
   * 
   * @param {*} container 
   * @param {*} completionRecord 
   * @returns 
   */
export const calculateLockerCompletionPercentage = (container, completionRecord) => {
  let containerContents = container.flattenContainerContents();
  let totalComplete = 0;
  let totalHeadingContainers = 0;
  let totalAdjustForHeadingContainer = container.getHeading() === 1 ? 0 : 1;

  // For future me, this method of calculating the percentage is very ineffecinet and
  // there will performance issues with loading large inventories with many lockers/items.
  // This will need to be improved in the future. Basically, for every item in the 
  // flattened locker see if a Completion Record Transcript record exists with a matching ID.
  containerContents.forEach(element => {
    if (element.getHeading && element.getHeading() === 1) {
      totalHeadingContainers++;
      return;
    }

    if (completionRecord.getTranscripts().filter((crt) => {
      let isContainer = element.getType() === Constants.InventoryType.Container;
      return crt.getItemId() == element.getId() && crt.isContainer() == isContainer;
    }).length > 0) {
      totalComplete++;
    }
  });

  /**
   * Percentage is calculated using the following variables.
   * 
   * totalComplete -> total number of items that were marked off by the user
   * containerContents.length -> total number of items in the container. This is inclusive of the container itself
   * totalHeadingContainers -> total number of containers that are HEADING contaienrs and are not marked off by users
   * totalAdjustForHeadingContainer -> If the parent container is a Heading dont need to worray about it, as we dont 
   *                                   mark off a heading. But if the parent container is a normal container, than we 
   *                                   need to remove it from the total as the code will expect it to be marked off, 
   *                                   but it wont be. This is due to normal containers being used as a Locker instead 
   *                                   of a Heading container.
   */

  let percent = Math.round((totalComplete / (containerContents.length - totalHeadingContainers - totalAdjustForHeadingContainer)) * 100);

  return isNaN(percent) ? 100 : percent;
}